import React, { useState, useEffect, useRef } from "react";
import { Box, Typography, IconButton, Grid, Modal, Button, Stack } from "@mui/material";
import CustomTextField from "../commoncomponents/CustomTextField";
import { DefaultCard } from "../../assets/styled-components/card";
import CustomFooter from "../commoncomponents/CustomFooter";
import { useNavigate, useLocation } from "react-router";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import axios from "axios";
import { getAuthToken, getFacilityId, getuserId } from "../../utility/tokenUtility";
import CustomDialog from "../commoncomponents/CustomDialog";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import CustomDateTimePicker from "../commoncomponents/CustomDateTimePicker";
import dayjs from "dayjs";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import { workrequest } from "../../utility/message";
import PageTitle from "../commoncomponents/PageTitle";
import { useDispatch } from "react-redux";
import { updateWorkOrderStatus } from "../../redux/actions/workOrderActionTypes";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import moment from "moment";
import Departmentworkrequestattachments from "./Departmentworkrequestattachments";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
import PageLoader from "../commoncomponents/PageLoader";

const Createdepartmentworkrequest = () => {
    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, "ENGT001");
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { state } = location;
    const [selectedDate, setSelectedDate] = useState(dayjs().format("YYYY-MM-DDTHH:mm:ss"));
    const [id, SetDepartmentid] = useState(state?.id || '');
    const [deptworkrequestno, setWorkRequestNo] = useState('');
    const [hospital, setHospital] = useState('');
    const [requestor, setRequestor] = useState(localStorage.getItem('UserName')||'');
    const [designation, setDesignation] = useState(localStorage.getItem('roleName') ||'');
    const [contactno, setContactNo] = useState('');
    const [selectedAsset, setSelectedAsset] = useState(state?.assetno || '');
    const [datetime, setDateTime] = useState(dayjs().format("YYYY-MM-DDTHH:mm:ss"));
    const [pageLoading, setPageLoading] = useState(false)

    const [assetDetails, setAssetDetails] = useState({
        value: '',
        label: state?.assetno || '',
        descrption: state?.assetdesc || '',
        locationId: state?.locationId || '',
        location: state?.locationName || '',
        model: state?.model || '',
        serialNo: state?.serialno || '',
        serviceId: '',
        service: '',
        workGroup: '',
        oldasseono: '',
        isunderwarranty: '',
        workgroupdescrption: '',
        workGroupId:'',
        repairTypeId: '',
        repairType: ''
    });
   
    const [requestdetails, setRequestDetails] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);
    const [readOnly, setReadOnly] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isView, setIsView] = useState(false);
    const [isAddNew, setIsAddNew] = useState(false);
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [typeOptions, setTypeOptions] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [selectedType, setSelectedType] = useState([]);
    const [assetOptions, setAssetOptions] = useState([]);
    const [loadingAssets, setLoadingAssets] = useState(true);
    const [isSaveDisabled, setIsSaveDisabled] = useState(false);
    const [errors, setErrors] = useState({
        deptworkrequestno: false,
        requestor: false,
        designation: false,
        contactno: false,
        assetno: false,
        requestdetails: false,
        selectedDate: false,
    });
    const [errorMessages, setErrorMessages] = useState({

        deptworkrequestno: '',
        requestor: '',
        designation: '',
        contactno: '',
        assetno: '',
        requestdetails: '',
        selectedDate: '',
    });
    const [openValidationDialog, setOpenValidationDialog] = useState(false);
    const [dialogContent, setDialogContent] = useState('');
    const [isChanged, setIsChanged] = useState(false);
    const userid = getuserId('UserId');
    const workRequestNoRef = useRef(null);
    const requestorRef = useRef(null);
    const [conformation,setConformation] = useState(false);

    const attchmentRef = useRef(null);

    const [afterUpdateId, setAfterUpdateId] = useState('');

    useEffect(() => {
        if (isEdit) {
            requestorRef.current.focus();
        } else {
            workRequestNoRef.current.focus();
        }
    }, [isEdit]);




    const handleWorkRequestNoChange = (newValue) => {

    };

    const handleRequestorChange = (newValue) => {
        setIsChanged(true); // Set unsaved changes flag

        setRequestor(newValue);
        setConformation(true);
        if (newValue.startsWith(' ')) {
            setErrors((prevErrors) => ({ ...prevErrors, requestor: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, requestor: 'Invalid Input. Only letters, numbers, spaces, and the characters ,-!@#$%&*()_- are allowed.' }));
        } else if (newValue.includes('  ')) {
            setErrors((prevErrors) => ({ ...prevErrors, requestor: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, requestor: 'Invalid Input. Only letters, numbers, spaces, and the characters ,-!@#$%&*()_- are allowed.' }));
        }
        //  else if (/[^a-zA-Z0-9 ,!@#$%&*()_-]/.test(newValue)) {
        //     setErrors((prevErrors) => ({ ...prevErrors, requestor: true }));
        //     setErrorMessages((prevMessages) => ({
        //         ...prevMessages,
        //         requestor: 'Invalid Input. Only letters, numbers, spaces, and the characters ,-!@#$%&*()_- are allowed.'
        //     }));
        // } 
        else {
            setErrors((prevErrors) => ({ ...prevErrors, requestor: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, requestor: '' }));
        }
    };

    const handleDesignationChange = (newValue) => {
        setIsChanged(true); // Set unsaved changes flag
        setDesignation(newValue);
        setConformation(true);
        setErrors((prevErrors) => ({ ...prevErrors, designation: false }));
        setErrorMessages((prevMessages) => ({ ...prevMessages, designation: '' }));
    };

    
    const test = (value) => {
        // Regex pattern to allow digits, '+' and '-'
        const regex = /^[0-9+-]+$/;
        return regex.test(value);
    };
    const handleContactNoChange = (newValue) => {
        setIsChanged(true); // Set unsaved changes flag

        if (newValue === '') {
            // Handle case when input is empty
            setContactNo('');
            setErrors((prevErrors) => ({ ...prevErrors, contactno: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, contactno: '' }));
        } else if (test(newValue)) {
            // Handle case when input is valid

            setContactNo(newValue);
            setConformation(true);
            setErrors((prevErrors) => ({ ...prevErrors, contactno: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, contactno: '' }));
        } else {
            // Handle case when input is invalid
            setErrors((prevErrors) => ({ ...prevErrors, contactno: true }));
            setErrorMessages((prevMessages) => ({
                ...prevMessages,
                contactno: 'Invalid Contact No'
            }));
        }
    };

    const handleRequestDetailsChange = (newValue) => {
        setIsChanged(true); // Set unsaved changes flag

        setRequestDetails(newValue);
        setConformation(true);

        if (newValue.startsWith(' ')) {
            setErrors((prevErrors) => ({ ...prevErrors, requestdetails: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, requestdetails: 'Invalid Input. Only letters, numbers, spaces, and the characters ,-!@#$%&*()_-/ are allowed.' }));
        } else if (newValue.includes('  ')) {
            setErrors((prevErrors) => ({ ...prevErrors, requestdetails: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, requestdetails: 'Invalid Input. Only letters, numbers, spaces, and the characters ,-!@#$%&*()_-/ are allowed.' }));
        } else if (/[^a-zA-Z0-9 ,!@#$%&*()_/-]/.test(newValue)) {
            setErrors((prevErrors) => ({ ...prevErrors, requestdetails: true }));
            setErrorMessages((prevMessages) => ({
                ...prevMessages,
                requestdetails: 'Invalid Input. Only letters, numbers, spaces, and the characters ,-!@#$%&*()_-/ are allowed.'
            }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, requestdetails: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, requestdetails: '' }));
        }
    };

    const handleDateChange = (formattedDate) => {
        const selectedDateTime = dayjs(formattedDate, "YYYY-MM-DDTHH:mm:ss");
        const currentDate = dayjs().startOf("day");
        const currentDateTime = dayjs();

        const isFutureDate = selectedDateTime.isAfter(currentDate, "day");
        const isFutureTime = selectedDateTime.isSame(currentDate, "day") && selectedDateTime.isAfter(currentDateTime);

        if (isFutureDate || isFutureTime) {
            setErrors((prevErrors) => ({ ...prevErrors, selectedDate: true }));
            setErrorMessages((prevErrorMessages) => ({
                ...prevErrorMessages,
                selectedDate: "Future date and time are not allowed",
            }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, selectedDate: false }));
            setErrorMessages((prevErrorMessages) => ({
                ...prevErrorMessages,
                selectedDate: "",
            }));
            setSelectedDate(formattedDate);
            setIsChanged(true);
        }
    };

    const validateDateTime = (dateTime) => {
        const selectedDateTime = dayjs(dateTime, "YYYY-MM-DDTHH:mm:ss");
        const currentDate = dayjs().startOf("day");
        const currentDateTime = dayjs();

        const isFutureDate = selectedDateTime.isAfter(currentDate, "day");
        const isFutureTime = selectedDateTime.isSame(currentDate, "day") && selectedDateTime.isAfter(currentDateTime);

        return !(isFutureDate || isFutureTime);
    };

    const handleCategoryChange = (selectedOptions) => {
        //  console.log('handleCategoryChange - selectedOptions:', selectedOptions);
        setIsChanged(true);
        setConformation(true);
        setSelectedCategory(selectedOptions?.value);
        // handleStatusChange can be updated here if needed
    };

    const handleTypeChange = (selectedOption) => {
        setIsChanged(true);
        setConformation(true);
        setSelectedType(selectedOption?.value);
    };

    // Handler function for hospital change
    const handleHospitalChange = (newValue) => {
        setHospital(newValue);
        // Update localStorage with the new hospital value
        localStorage.setItem('FacilityName', newValue);
    };




    const handleAssetChange = (newValue) => {
        // console.log("newValue", newValue);

        if (newValue && newValue.value) {
            const selectedValue = newValue.value;
            const selectedAssetDetails = assetOptions.find(asset => asset.value === selectedValue);
            
            if (selectedAssetDetails) {
                setSelectedAsset({ ...newValue, label: newValue.label.split('-')[0].trim() });
                setConformation(true);
                setAssetDetails({
                    id: selectedAssetDetails.value,
                    assetno: selectedAssetDetails.label.split('-')[0].trim(),
                    descrption: selectedAssetDetails.descrption,
                    model: selectedAssetDetails.model,
                    serialNo: selectedAssetDetails.serialNo,
                    locationId: selectedAssetDetails.locationId,
                    location: selectedAssetDetails.location,
                    serviceId: selectedAssetDetails.serviceId,
                    service: selectedAssetDetails.service,
                    oldasseono: selectedAssetDetails.oldasseono,
                    workGroup: selectedAssetDetails.workGroup,
                    isunderwarranty: selectedAssetDetails.isunderwarranty,
                    workgroupdescrption: selectedAssetDetails.workgroupdescrption,
                    workGroupId: selectedAssetDetails.workGroupId,
                    repairTypeId: selectedAssetDetails.repairTypeId,
                    repairType: selectedAssetDetails.repairType,
                });

                setErrors((prevErrors) => ({ ...prevErrors, selectedAsset: false }));
                setErrorMessages((prevErrorMessages) => ({ ...prevErrorMessages, selectedAsset: '' }));

                if (selectedAsset !== newValue) {
                    setIsChanged(true);
                }
            }
        } else {
            setSelectedAsset('');  // Clear the selected asset
            setAssetDetails({
                id: '',
                assetno: '',
                descrption: '',
                model: '',
                serialNo: '',
                location: '',
                serviceId: '',
                locationId: '',
                service: '',
                oldasseono: '',
                workGroup: '',
                isunderwarranty: '',
                workgroupdescrption: '',
                workGroupId:'',
                repairTypeId: '',
                repairType: ''
            });

            setIsChanged(false);
        }
    };


    useEffect(() => {
        const storedHospital = localStorage.getItem('FacilityName');
        if (storedHospital) {
            setHospital(storedHospital);
        }
    }, []);
    const facilityid = getFacilityId();


    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);
    const [gridApi, setGridApi] = useState({});

    const columns = [
        {
            headerName: 'Asset No',
            field: 'label',
            width: 150,
            cellRenderer: (params) => (
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        handleAssetClick(params.data);  // Call the handleAssetClick function with the clicked asset's data
                    }}
                    style={{
                        color: 'blue',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                    }}
                >
                    {params.value}
                </a>
            ),
        },
        { headerName: 'Description', field: 'descrption', width: 200 },
        { headerName: 'Service', field: 'service', width: 100 },
        { headerName: 'Model', field: 'model', width: 150 },
        { headerName: 'Workgroup Code', field: 'workGroup', width: 150 },
        { headerName: 'Department Code', field: 'department', width: 150 },
        { headerName: 'Location', field: 'location', width: 150 },
        { headerName: 'Serial No.', field: 'serialNo', width: 150 },
        { headerName: 'Old Asset No.', field: 'oldasseono', width: 150 },


    ];



    const handleAssetClick = (rowData) => {
        // Handle the asset click, but now we will close the modal afterward
        // console.log('Asset clicked:', rowData);

        // Update the selected asset value
        setSelectedAsset(rowData.label); // Set the label or any other desired value

        // Update asset details if necessary (optional, based on your setup)
        if (rowData && rowData.value) {
            const selectedValue = rowData.value;
            const selectedAssetDetails = assetOptions.find(asset => asset.value === selectedValue);

            if (selectedAssetDetails) {
                setSelectedAsset({ ...rowData, label: rowData.label.split('-')[0].trim() });
                setConformation(true);
                setAssetDetails({
                    id: selectedAssetDetails.value,
                    assetno: selectedAssetDetails.label.split('-')[0].trim(),
                    descrption: selectedAssetDetails.descrption,
                    model: selectedAssetDetails.model,
                    serialNo: selectedAssetDetails.serialNo,
                    locationId: selectedAssetDetails.locationId,
                    location: selectedAssetDetails.location,
                    serviceId: selectedAssetDetails.serviceId,
                    service: selectedAssetDetails.service,
                    oldasseono: selectedAssetDetails.oldasseono,
                    workGroup: selectedAssetDetails.workGroup,
                    isunderwarranty: selectedAssetDetails.isunderwarranty,
                    workgroupdescrption: selectedAssetDetails.workgroupdescrption,
                    workGroupId:selectedAssetDetails.workGroupId,
                    repairTypeId: selectedAssetDetails.repairTypeId,
                    repairType: selectedAssetDetails.repairType,
                    
                });

                setErrors((prevErrors) => ({ ...prevErrors, selectedAsset: false }));
                setErrorMessages((prevErrorMessages) => ({ ...prevErrorMessages, selectedAsset: '' }));

                if (selectedAsset !== rowData) {
                    setIsChanged(true);
                }
            }
        } else {
            setSelectedAsset(''); // Clear the selected asset
            setAssetDetails({
                id: '',
                assetno: '',
                descrption: '',
                model: '',
                serialNo: '',
                location: '',
                serviceId: '',
                locationId: '',
                oldasseono: '',
                workGroup: '',
                isunderwarranty: '',
                workgroupdescrption: '',
                workGroupId:'',
                repairTypeId: '',
                repairType: ''
            });

            setIsChanged(false);
        }

        // Close the modal after asset selection
        handleCloseModal();
    };


    /// Asset No 
    useEffect(() => {
        const fetchAssetRegisters = async () => {
            try {
                const token = getAuthToken("id_token");
                const config = {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                };

                let responseFems = [], responseBems = [];

                if ( localStorage?.getItem("roleName") !== "DeptUser") {
                    
                    [responseFems, responseBems] = await Promise.all([
                        axios.get(`${FemsGraph}/api/GraphFemsAssetregisterlist/GetAssetRegisterListServiceid/${facilityid}`, config),
                        axios.get(`${BemsGraph}/api/GraphBemsAssetregisterlist/GetAssetRegisterListServiceid/${facilityid}`, config)
                    ]);
                }
                else {
                    
                    [responseFems, responseBems] = await Promise.all([
                        axios.get(`${FemsGraph}/api/UserLocationCode/GetDepartmentuserAssetnolookup/${userid}/${facilityid}/${token}`, config),
                        axios.get(`${BemsGraph}/api/UserLocationCode/GetDepartmentuserAssetnolookup/${userid}/${facilityid}/${token}`, config)
                    ]);
                }

                const formattedDataFems = responseFems?.data?.map(asset => ({
                    value: asset.id,
                    label: asset.assetNo,  // This field corresponds to 'Asset No'
                    descrption: asset.descrption,
                    model: asset.model,
                    serialNo: asset.serialNo,
                    locationId: asset.locationid,
                    location: asset.location,
                    serviceId: asset.serviceId,
                    service: 'FEMS',
                    department: asset.departmentcode,
                    oldasseono: asset.oldasseono,
                    workGroup: asset.workGroup,
                    isunderwarranty: asset.isunderwarranty,
                    workgroupdescrption: asset.workgroupdescrption,
                    workGroupId:asset.workGroupId,
                    repairTypeId: asset.repairTypeId,
                    repairType: asset.repairType,

                }));

                const formattedDataBems = responseBems?.data?.map(asset => ({
                    value: asset.id,
                    label: asset.assetNo,
                    descrption: asset.descrption,
                    model: asset.model,
                    serialNo: asset.serialNo,
                    locationId: asset.locationid,
                    location: asset.location,
                    serviceId: asset.serviceId,
                    service: 'BEMS',
                    department: asset.departmentcode,
                    oldasseono: asset.oldasseono,
                    workGroup: asset.workGroup,
                    isunderwarranty: asset.isunderwarranty,
                    workgroupdescrption: asset.workgroupdescrption,
                    workGroupId:asset.workGroupId,
                    repairTypeId: asset.repairTypeId,
                    repairType: asset.repairType,
                }));

                const combinedData = [...formattedDataFems || [], ...formattedDataBems || []];
                setAssetOptions(combinedData);
                setLoadingAssets(false);
            } catch (error) {
                console.log(error,"erro fetching");
                
            }
        };

        fetchAssetRegisters();
    }, []);

    //fetch Categories
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const token = getAuthToken("id_token");
                const config = {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                };

                const response = await axios.get(`${FemsGraph}/api/femworkordercategories`, config);
                const formattedData = response.data
                    .filter(category => category.workordercategory !== "Scheduled" && category.workordercategory !== "Others") // Exclude category with ID 2
                    .map(category => ({
                        value: category.id,
                        label: category.workordercategory,
                    }));
                setCategoryOptions(formattedData);

                // Update selectedCategory state based on location.state or default
                let initialCategory = null;
                if (location.state && location.state.categoryId) {
                    initialCategory = location.state.categoryId.value;
                } else if (formattedData.length > 0) {
                    initialCategory = formattedData[0].value;
                }

                setSelectedCategory(initialCategory);

                // If a category was selected, fetch the types
                if (initialCategory !== null) {
                    fetchTypes(initialCategory);
                }
            } catch (error) {
                // console.error('Error fetching categories:', error);
            }
        };

        //FetchTypes
        const fetchTypes = async (categoryId) => {
            try {
                const token = getAuthToken("id_token");
                const config = {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                };

                const response = await axios.get(`${FemsGraph}/api/Femworkrequesttypelist/Getworkrequestordertype/${categoryId}`, config);
                const formattedData = response.data
                    .filter(type => type.workordertype !== "Warranty Breakdown" && type.workordertype !== "Safety & Performance")
                    .map(type => ({
                        value: type.id,
                        label: type.workordertype,
                    }));
                setTypeOptions(formattedData);

                // Update selectedType state based on location.state or default
                if (location.state && location.state.typeId) {
                    setSelectedType(location.state.typeId.value);
                } else if (formattedData.length > 0) {
                    setSelectedType(formattedData[0].value);
                }
            } catch (error) {
                // console.error('Error fetching types:', error);
            }
        };

        fetchCategories();
    }, [location.state]);

    // Handle Submit Validation 
    const handleSubmit = (e) => {
        e.preventDefault();

        let formIsValid = true;
        const newErrors = {
            deptworkrequestno: false,
            requestor: false,
            selectedAsset: false,
            requestdetails: false,
            selectedDate: false,
            

        };
        const newErrorMessages = {
            deptworkrequestno: '',
            requestor: '',
            selectedAsset: '',
            requestdetails: '',
            selectedDate: '',

        };



        // Validation for requestor
        if (!requestor) {
            formIsValid = false;
            newErrors.requestor = true;
            newErrorMessages.requestor = 'Requestor is required';
        } else if (requestor.startsWith(' ')) {
            formIsValid = false;
            newErrors.requestor = true;
            newErrorMessages.requestor = 'Invalid Input a-zA-Z0-9,-_!@#$%&*() - Only these characters are allowed';
        } else if (/  /.test(requestor)) {
            formIsValid = false;
            newErrors.requestor = true;
            newErrorMessages.requestor = 'Invalid Input a-zA-Z0-9,-_!@#$%&*() - Only these characters are allowed';
        } 
        // else if (/[^a-zA-Z0-9 ,!@#$%&*()_-]/.test(requestor)) {
        //     formIsValid = false;
        //     newErrors.requestor = true;
        //     newErrorMessages.requestor = 'Invalid Input a-zA-Z0-9,-_!@#$%&*() - Only these characters are allowed';
        // }

        // Validation for selectedAsset
        if (!selectedAsset?.label) {
            formIsValid = false;
            newErrors.selectedAsset = true;
            newErrorMessages.selectedAsset = 'Asset No is required';
        } else {
            newErrors.selectedAsset = false;
            newErrorMessages.selectedAsset = '';
        }
        if (!requestdetails) {
            formIsValid = false;
            newErrors.requestdetails = true;
            newErrorMessages.requestdetails = 'Request Details are required';
        } else if (requestdetails.startsWith(' ')) {
            formIsValid = false;
            newErrors.requestdetails = true;
            newErrorMessages.requestdetails = 'Invalid Input a-zA-Z0-9,-_!@#$%&*() - Only these characters are allowed';
        } else if (/  /.test(requestdetails)) {
            formIsValid = false;
            newErrors.requestdetails = true;
            newErrorMessages.requestdetails = 'Invalid Input a-zA-Z0-9,-_!@#$%&*() - Only these characters are allowed';
        } else if (/[^a-zA-Z0-9 ,!@#$%&*()_/-]/.test(requestdetails)) {
            formIsValid = false;
            newErrors.requestdetails = true;
            newErrorMessages.requestdetails = 'Invalid Input a-zA-Z0-9,-_!@#$%&*() - Only these characters are allowed';
        }

        // Validation for selectedDate

        if (errors.selectedDate) {
            newErrors.selectedDate = true;
            newErrorMessages.selectedDate = errorMessages.selectedDate;
        }

        // Set state with new errors and error messages
        setErrors(newErrors);
        setErrorMessages(newErrorMessages);


        if (newErrors.deptworkrequestno || newErrors.requestor || newErrors.selectedAsset || newErrors.requestdetails || newErrors.selectedDate) {
            formIsValid = false;
        }

        // If form is valid, proceed with saving
        if (formIsValid) {
            handleSave();
        }
    };

    //updating 
    useEffect(() => {
        if (location.state) {
            //    console.log("Editing row data:", location.state);

            SetDepartmentid(state?.id || afterUpdateId ||'');
            setWorkRequestNo(state?.deptworkrequestno || '');
            setRequestor(state?.requestor || '');
            setDesignation(state?.designation || '');
            setContactNo(state?.contactno || '');
            setSelectedAsset(state?.assetno || '');
            setAssetDetails({
                id: state?.assetno?.value || '',
                assetno: state?.assetno?.label || '',
                descrption: state?.assetdesc || '',
                locationId: state?.locationId || '',
                location: state?.locationName || '',
                model: state?.model || '',
                serialNo: state?.serialno || '',
                serviceId: state?.serviceId || '',
                service: state?.service || assetDetails.service,
                workGroup:state?.workcode || assetDetails.workGroup || '',
                oldasseono: state?.oldAssetno ||assetDetails.oldasseono ||'',
                isunderwarranty: state?.isunderwarranty || assetDetails.isunderwarranty ||'',
                workgroupdescrption:state?.workgroup ||assetDetails.workgroupdescrption || '',
                workGroupId:state?.workGroupId || assetDetails.workGroupId || '',
                repairTypeId:state?.repairTypeId || assetDetails.repairTypeId || '',
                repairType:state?.repairType || assetDetails.repairType || '',
            });
            setSelectedDate(state?.deptworkrequestdate || '');
            setSelectedCategory(state?.categoryId?.label || '');
            setSelectedType({ workordertype: state?.typeId?.label || selectedType ||'' });
            setRequestDetails(state?.requestdetails || '');
            setReadOnly(state?.readOnly || false);
            setIsView(state.isViewMode);
            setIsEdit(state.isEditMode);

        } else {
            setIsEdit(false);
            setIsView(false);
        }
    }, [location.state]);


    const handleCancel = () => {
        if (!isChanged) {
            navigate(-1, { replace: true });
        }
        else {
            setCancelDialogOpen(true)
            setDialogContent("Record(s) not Saved/Updated. Do you want to continue?")
        }
    };


    //save Method 
    const handleSave = async () => {
       
        try {
            setPageLoading(true);
            let generatedNo = deptworkrequestno; // Default to the current state value

            // Only fetch the deptworkrequestno if in create mode
            if (!isEdit) {
                const token = getAuthToken("id_token");
                const config = {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                };

                // Fetch the department work request number
                const response = await axios.get(`${MasterGraph}/api/GraphDocumentSerialNumber/GetDocumentSerialNumberDetails/${facilityid}/WR/${token}`, config);
                generatedNo = response?.data; // Extract the department work request number from the response

                // Update the state before proceeding
                setWorkRequestNo(generatedNo);


                // await new Promise((resolve) => setTimeout(resolve, 0));
            }

            const serviceName = location?.state?.service === 'FEMS' ? "femassetregisterId" : "bemassetregisterId";
            // Proceed with the save operation using the generated or existing deptworkrequestno
            let putcommonData = {
                id: id,
                requestor: requestor,
                designation: designation,
                contactno: contactno,
                requestdetails: requestdetails,
                typeId: selectedType,
                [`${serviceName}`]:assetDetails.id
                
            };
            let commonData = {
                id: id,
                requestor: requestor,
                designation: designation,
                contactno: contactno,
                requestdetails: requestdetails,
                typeId: selectedType,
            };

            let createData = {
                ...commonData,
                deptworkrequestdate: datetime || moment(selectedDate).format("YYYY-MM-DDTHH:mm:ss"),
                createdby: userid,
                isdeleted: false,
                deptworkrequestno: generatedNo, // Use the fetched or existing deptworkrequestno
                facilityid: facilityid,
            };

            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            };

            let apiUrl;
            if (assetDetails.service === 'FEMS') {
                apiUrl = `${FemsGraph}/api/femdepartmentworkrequestheaders`;
                createData = {
                    ...createData,
                    femassetregister: {
                        id: assetDetails.id,
                        assetno: assetDetails.assetno,
                        assetdesc: assetDetails.descrption,
                        userlocationid: assetDetails.locationId,
                        locationName: assetDetails.location,
                        model: assetDetails.model,
                        serialNo: assetDetails.serialNo,
                    },
                    femworkordertype: {
                        id: selectedType,
                        workordertype: typeOptions.find(type => type.value === selectedType)?.label || "",
                    },
                    femworkorderstatus: {
                        id: workrequest.statusvalue,
                        Workorderstatus: workrequest.statuslabel,
                    },
                };
            }

            if (assetDetails.service === 'BEMS') {
                apiUrl = `${BemsGraph}/api/bemdepartmentworkrequestheaders`;
                createData = {
                    ...createData,
                    bemassetregister: {
                        id: assetDetails.id,
                        assetno: assetDetails.assetno,
                        assetdesc: assetDetails.descrption,
                        userlocationid: assetDetails.locationId,
                        locationName: assetDetails.location,
                        model: assetDetails.model,
                        serialNo: assetDetails.serialNo,
                    },
                    bemworkordertype: {
                        id: selectedType,
                        workordertype: typeOptions.find(type => type.value === selectedType)?.label || "",
                    },
                    bemworkorderstatus: {
                        id: workrequest.statusvalue,
                        Workorderstatus: workrequest.statuslabel,
                    },
                };
            }

            // Make the save API call
            let response;

            let servicepayloadbems =
            {
                deptworkrequestno: location?.state?.deptworkrequestno || '',
                requestor: requestor || location?.state?.requestor || '',
                designation: designation || location?.state?.designation || '',
                contactno: contactno || location?.state?.contactno || '',
                requestdetails: requestdetails || location?.state?.requestdetails || '',
                typeId: selectedType || location?.state?.typeId || '',
                deptworkrequestdate: location?.state?.deptworkrequestdate || moment(selectedDate).format("YYYY-MM-DDTHH:mm:ss"),
                bemassetregisterid : assetDetails.id,
                bemworkordertypeid : selectedType || location?.state?.typeId || '',
                bemworkorderstatusid : workrequest.statusvalue,
                facilityid: facilityid,
            }

            let servicepayloadfems =
            {
                deptworkrequestno: location?.state?.deptworkrequestno || '',
                requestor: requestor || location?.state?.requestor || '',
                designation: designation || location?.state?.designation || '',
                contactno: contactno || location?.state?.contactno || '',
                requestdetails: requestdetails || location?.state?.requestdetails || '',
                typeId: selectedType || location?.state?.typeId || '',
                deptworkrequestdate: location?.state?.deptworkrequestdate || moment(selectedDate).format("YYYY-MM-DDTHH:mm:ss"),
                femassetregisterid : assetDetails.id,
                femworkordertypeid : selectedType || location?.state?.typeId || '',
                femworkorderstatusid : workrequest.statusvalue
            }
            if (isEdit) {
                let id = location.state?.id || '';
                let Service =  location.state?.service;
                let apiurl1 = `${FemsGraph}/api/Femworkrequesttypelist/UpdateDerpartmentworkrequest/${id}`;
                let apiurl2 = `${BemsGraph}/api/GraphBemworkrequesttypelist/UpdateDerpartmentworkrequestbems/${id}`;
                let apiUrl3 = `${BemsGraph}/api/bemdepartmentworkrequestheaders`;
                let apiUrl4 = `${FemsGraph}/api/femdepartmentworkrequestheaders`;

                if (Service === 'FEMS' && assetDetails.service ==='FEMS') {
                  
                    response = await axios.put(apiurl1, putcommonData, config);
                 
                } else if (Service === 'BEMS' && assetDetails.service ==='BEMS') {
                   
                    response = await axios.put(apiurl2, putcommonData, config);
                  
                } else if (Service === 'FEMS' && assetDetails.service ==='BEMS'){
                 
                    response = await axios.delete(
                        `${FemsGraph}/api/femdepartmentworkrequestheaders/${location?.state?.id}`,
                        config);
                    response = await axios.post(apiUrl3, servicepayloadbems, config);
                    
                  
                }else if(Service === 'BEMS' && assetDetails.service ==='FEMS'){
                  
                    response = await axios.delete(
                        `${BemsGraph}/api/bemdepartmentworkrequestheaders/${location?.state?.id}`,
                        config
                      );
                    response = await axios.post(apiUrl4, servicepayloadfems, config);
 
                }

                if (response.status === 200) {
                   
                    if(attchmentRef.current){
                        attchmentRef.current.handleSaveClick(assetDetails.service, response?.data?.id);
                        attchmentRef.current.fetchFiles(response?.data?.id);
                    setOpenValidationDialog(true);
                    setDialogContent('Data updated successfully.');
                    setIsChanged(false);
                    setAfterUpdateId(response?.data?.id);
                    setIsSaveDisabled(true);
                    setConformation(false);
                    }
                }else if (response.status === 201)
                {
                    if(attchmentRef.current){
                        attchmentRef.current.handleSaveClick(assetDetails.service, response?.data?.id);
                        attchmentRef.current.fetchFiles(response?.data?.id);
                    setOpenValidationDialog(true);
                    setDialogContent('Data updated successfully.');
                    setIsChanged(false); 
                    setIsSaveDisabled(true);
                    setAfterUpdateId(response?.data?.id);
                    setConformation(false);
                    }
                }

            } else {
                response = await axios.post(apiUrl, createData, config);
               
                if (response.status === 201) {
                    // console.log("Response object:", response);
                    // console.log("Response ID:", response?.id); 
                    if(attchmentRef.current){
                        attchmentRef.current.handleSaveClick(assetDetails.service, response?.data?.id);
                        attchmentRef.current.fetchFiles(response?.data?.id);
                        setOpenValidationDialog(true);
                    setDialogContent('Work Request submitted successfully.');
                    setIsChanged(false);
                    setIsSaveDisabled(true);
                    // Update the UI with the saved deptworkrequestno
                    const savedWorkRequestNo = response.data.deptworkrequestno; // Adjust based on the response structure
                    setWorkRequestNo(savedWorkRequestNo);
                    }
                    
                }
            }
        } catch (error) {
            if (error.response && error.response.status === 400) {
                setDialogContent("Department Work Request No. Already Exist. Please check Document serial number.");
                setOpenValidationDialog(true);
            } else {
                console.error("Error:", error);
                setDialogContent("Some Fields Are Missing");
                setOpenValidationDialog(true);
            }
        } finally
        {
            setPageLoading(false);
        }
    };

    const setDefault = () => {

        setWorkRequestNo('');
        setRequestor('');
        setDesignation('');
        setContactNo('');
        setSelectedAsset({ label: '', value: '' });
        setAssetDetails({ label: '', value: '', location: '', descrption: '', model: '', serialNo: '' });
        // setSelectedType('');
        setRequestDetails('');
        // setSelectedDate(null);
        setReadOnly(false);
        setIsEditMode(false);
        setIsChanged(false)
        setIsAddNew(false)
        setErrors({})
        setErrorMessages({})
        setIsSaveDisabled(false);
        //  isFutureDate('')
        if (attchmentRef.current && attchmentRef.current.clear) {
            attchmentRef.current.clear();
        }

    };

    const handleAddNew = () => {
        if (isChanged) {
            setIsAddNew(true);
            setCancelDialogOpen(true);
            setDialogContent("Record(s) not Saved/Updated. Do you want to continue?");
           
        } else {
            setDefault();
            // setSelectedDate();
            setErrors({});
              // Clear Departmentworkrequestattachments
        if (attchmentRef.current && attchmentRef.current.clear) {
            attchmentRef.current.clear();
        }
        }
    };


    const handleDialogClose = () => {
        setCancelDialogOpen(false);
        setOpenValidationDialog(false);
        setIsChanged(false);
        // navigate(-1, { replace: true });
    };

    const handleCancelDialogClose = () => {
        setCancelDialogOpen(false);

    };

    const handleConfirmCancel = () => {
        setCancelDialogOpen(false)
        setOpenValidationDialog(false)
        if (isAddNew) {
            setDefault()
        }

        if (isChanged && !isAddNew && !openValidationDialog) {
            setCancelDialogOpen(false);
            navigate(-1, { replace: true });
        }

    };

    

    const handleConvert = () => {
        dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
        dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
        dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: "", percentage: 0 }))
        const title = `Create Unscheduled Work Order`;
        const buttonchange ="1";
        const departmentid = location?.state?.id || afterUpdateId;
        
        navigate("/workorder/register", { state: {buttonchange, title,isCreateMode:true, deptid: location?.state,departmentid, assetDetails, requestor,designation,contactno,selectedType,requestdetails,afterUpdateId } });
    };

    return (
        <>
        <PageLoader open={pageLoading} />
            <PageTitle
                title={'Create Department Work Request'}
                isEdit={isEdit}
                isView={isView}
                editTitle={'Edit Department Work Request'}
                viewTitle={'View Department Work Request'}
            />
            <Box mt={{ xs: 1, md: 2 }}>
                <DefaultCard sx={{ height: "100%" }}>
                    <form onSubmit={handleSubmit} style={{ position: "relative" }}>
                        <Box mb={2}>
                            <Grid container spacing={4}>
                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        label="Work Request No. (Auto)"
                                        id="deptworkrequestno"
                                        value={deptworkrequestno}
                                        onChange={handleWorkRequestNoChange}
                                        disabled={isView || isEdit}
                                        inputRef={workRequestNoRef}
                                        isRefilByOtherField={true}
                                        placeholder={false}
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        label="Hospital"
                                        id="hospital"
                                        value={hospital}
                                        onChange={handleHospitalChange}
                                        disabled={readOnly}
                                        isMandatoryField={false}
                                        isRefilByOtherField={true}
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        label="Requestor"
                                        id="requestor"
                                        value={requestor}
                                        onChange={handleRequestorChange}
                                        disabled={isView}
                                        isMandatoryField={true}
                                        error={errors.requestor}
                                        errorMessage={errorMessages.requestor}
                                        maxlength={60}
                                        inputRef={requestorRef}
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        label="Designation (Requestor)"
                                        id="designation"
                                        value={designation}
                                        onChange={handleDesignationChange}
                                        disabled={isView}
                                        isMandatoryField={false}
                                        maxlength={60}


                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        label="Contact No."
                                        id="contactno"
                                        value={contactno}
                                        onChange={handleContactNoChange}
                                        disabled={isView}
                                        isMandatoryField={false}
                                        error={errors.contactno}
                                        errorMessage={errorMessages.contactno}
                                        maxlength={20}
                                    />
                                </Grid>
                                <Grid item xs={6} md={ isView ? 4 : 3.5}>
                                    <CustomTextFieldWithSearch
                                        isMandatoryField={true}
                                        label="Asset No."
                                        id="assetno"
                                        disabled={ isView || (location?.state?.workorderNo !== "" && isEdit) }
                                        value={selectedAsset}
                                        options={assetOptions.map(option => ({
                                            label: `${option.label} - ${option.descrption}`,
                                            value: option.value
                                        }))}
                                        onChange={handleAssetChange}
                                        isDisable={false}
                                        error={errors.selectedAsset}
                                        errorMessage={errorMessages.selectedAsset}
                                        hideSearch={true}
                                    />
                                </Grid>


                                {(!isView) && (<Grid item xs={6} md={0.5} style={{ paddingLeft: "5px" }}>

                                    { !isView && (
                                        <Grid sx={{ mt: 2.7 }} item>
                                            <Button onClick={handleOpenModal} variant="contained" disabled ={(location?.state?.workorderNo !== "" && isEdit)}>
                                                <SearchIcon />
                                            </Button>
                                        </Grid>
                                    )}

                                    <Dialog
                                        open={isModalOpen}
                                        onClose={(event, reason) => {
                                            if (reason === "backdropClick") {
                                                return; // Prevent closing on backdrop click
                                            }
                                            handleCloseModal(); // Call the close function for other reasons
                                        }}
                                        // onClose={handleCloseModal}
                                        aria-labelledby="asset-grid-dialog"
                                        aria-describedby="grid-display-for-assets"
                                        maxWidth="lg"
                                        fullWidth
                                    ><DialogTitle
                                        id="asset-grid-dialog"
                                        sx={{
                                            fontWeight: 'bold',
                                            fontSize: '1.5rem', // Adjust font size as desired
                                            display: 'flex',
                                            justifyContent: 'space-between', // Space out title and icon
                                            alignItems: 'center',
                                        }}
                                    >
                                            Asset Search
                                            <IconButton
                                                aria-label="close"
                                                variant="outlined"
                                                onClick={handleCloseModal}
                                                sx={{
                                                    color: (theme) => theme.palette.grey[500],
                                                }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </DialogTitle>
                                        <DialogContent
                                            dividers
                                            sx={{
                                                overflowY: 'auto', // Enables scroll if content overflows
                                                height: 'auto',    // Allows height to adjust based on content
                                                maxHeight: 'auto', // Sets a maximum height to prevent it from growing too large
                                            }}
                                        >
                                            <CustomAgGrid
                                                rows={assetOptions}
                                                columns={columns}
                                                loading={loadingAssets}
                                                ref={gridApi}
                                                setGridApi={setGridApi}
                                            />
                                            <Stack my={3} direction={"row"} justifyContent={"end"}>
                                                <Button variant="outlined" onClick={handleCloseModal}>
                                                    Close
                                                </Button>
                                            </Stack>
                                        </DialogContent>
                                    </Dialog>

                                </Grid>)}

                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        label="Description"
                                        id="assetdesc"
                                        value={assetDetails.descrption}
                                        disabled={false}
                                        isMandatoryField={false}
                                        isRefilByOtherField={true}
                                        placeholder={false}
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        label="Location"
                                        id="location"
                                        value={assetDetails.location}
                                        disabled={readOnly}
                                        isMandatoryField={false}
                                        isRefilByOtherField={true}
                                        placeholder={false}
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        label="Model"
                                        id="model"
                                        value={assetDetails.model}
                                        disabled={readOnly}
                                        isMandatoryField={false}
                                        isRefilByOtherField={true}
                                        placeholder={false}
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        label="Serial No."
                                        id="serialno"
                                        value={assetDetails.serialNo}
                                        disabled={readOnly}
                                        isMandatoryField={false}
                                        isRefilByOtherField={true}
                                        placeholder={false}
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomSelectInput
                                        id="Category"
                                        label="Category"
                                        value={categoryOptions.find(option => option.value === selectedCategory) || null}
                                        options={categoryOptions}
                                        onChange={handleCategoryChange}
                                        disabled={isView}
                                        isMandatoryField={false}
                                        disableClearable={true}
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomSelectInput
                                        id="Type"
                                        label="Type"
                                        value={typeOptions.find(option => option.value === selectedType) || null}
                                        options={typeOptions}
                                        onChange={handleTypeChange}
                                        disabled={isView}
                                        isMandatoryField={false}
                                        disableClearable={true}
                                    />
                                </Grid>


                                <Grid item xs={6} md={4}>
                                    <CustomDateTimePicker
                                        label="Request Date and Time"
                                        value={selectedDate}
                                        onDateChange={handleDateChange}
                                        isMandatoryField={true}
                                        disabled={true}
                                        error={!!errors.selectedDate}
                                        helperText={errorMessages.selectedDate}
                                        isRefilByOtherField={false}

                                    />
                                </Grid>
                                <Grid item xs={6} md={8}>
                                    <CustomTextField
                                        label="Request Details"
                                        id="requestdetails"
                                        value={requestdetails}
                                        onChange={handleRequestDetailsChange}
                                        disabled={isView}
                                        isMandatoryField={true}
                                        error={errors.requestdetails}
                                        errorMessage={errorMessages.requestdetails}
                                        maxlength={255}
                                    />
                                </Grid>

                            </Grid>
                        </Box>
                    </form>
                    <DefaultCard>
                            <Departmentworkrequestattachments service={assetDetails.service} ref={attchmentRef} />
                        </DefaultCard>

                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,
                            justifyContent: { xs: "center", md: "end" },
                        }}
                    >
                       

                        <CustomFooter
                            cancelClick={handleCancel}
                            saveClick={handleSubmit}
                            addClick={handleAddNew}
                            convertClick={handleConvert}
                            readOnly={isView}
                            showconvertbutton={location?.state?.status === "Open" && localStorage.getItem("roleName") !== "DeptUser" && (location?.state?.workorderNo ==="" ||  !location?.state?.workorderNo) && access?.canCreate}
                            buttonLabel={isEdit ? "Update" : "Submit"}
                            isEdit={isEdit}
                            showAddButton={true}
                            saveDisabled={isSaveDisabled}
                            disableWoConversionButton={conformation}
                        />

                    </Box>
                </DefaultCard>

            </Box>
            <CustomDialog
                open={openValidationDialog}
                onConfirm={handleConfirmCancel}
                onClose={handleDialogClose}
                content={dialogContent}
                confirmBtn={'Ok'}
            />


            <CustomDialog
                open={cancelDialogOpen}
                onClose={handleCancelDialogClose}
                onConfirm={handleConfirmCancel}
                content={dialogContent}
                confirmBtn={'Yes'}
                cancelBtn={'No'}
            />
        </>
    );
};

export default Createdepartmentworkrequest;
